<!-- eslint-disable max-len -->
<script setup>
// eslint-disable-next-line no-undef
defineProps({
  icon: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'sm',
    validator(value) {
      return ['sm', 'md'].includes(value);
    },
  },
});

const icons = {
  'arrow-left': '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H17C17.2761 9.5 17.5 9.72386 17.5 10C17.5 10.2761 17.2761 10.5 17 10.5H3C2.72386 10.5 2.5 10.2761 2.5 10Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.64645 9.64645C2.84171 9.45118 3.15829 9.45118 3.35355 9.64645L9.35355 15.6464C9.54882 15.8417 9.54882 16.1583 9.35355 16.3536C9.15829 16.5488 8.84171 16.5488 8.64645 16.3536L2.64645 10.3536C2.45118 10.1583 2.45118 9.84171 2.64645 9.64645Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.35355 3.64645C9.54882 3.84171 9.54882 4.15829 9.35355 4.35355L3.35355 10.3536C3.15829 10.5488 2.84171 10.5488 2.64645 10.3536C2.45118 10.1583 2.45118 9.84171 2.64645 9.64645L8.64645 3.64645C8.84171 3.45118 9.15829 3.45118 9.35355 3.64645Z"/>',
  'support-message': '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C6.134 3 3 6.13401 3 10C3 11.1187 3.26205 12.1747 3.72766 13.1114C3.92575 13.5099 3.92492 14.026 3.8745 14.4813C3.82146 14.9602 3.69966 15.4782 3.56608 15.9465C3.45426 16.3384 3.33125 16.7055 3.22598 17H10C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM2.03907 17.3077L2.03957 17.3065L2.04194 17.3007L2.05185 17.2765C2.06067 17.2548 2.07377 17.2223 2.0904 17.1802C2.12366 17.096 2.17097 16.9737 2.22628 16.8234C2.33718 16.5222 2.47898 16.1119 2.60445 15.6721C2.7307 15.2296 2.83623 14.7716 2.88057 14.3712C2.92752 13.9473 2.8941 13.6811 2.83219 13.5566C2.29937 12.4847 2 11.2766 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18H2.50166L2.5006 17.5V18C2.33344 18 2.17734 17.9165 2.0846 17.7774C1.99188 17.6383 1.97484 17.462 2.03907 17.3077C2.03908 17.3076 2.03906 17.3077 2.03907 17.3077ZM9.96924 7.375C9.4263 7.375 8.96884 7.74633 8.8393 8.24963C8.77047 8.51706 8.49788 8.67805 8.23045 8.60922C7.96302 8.54039 7.80203 8.2678 7.87086 8.00037C8.11135 7.06598 8.95897 6.375 9.96924 6.375C11.1659 6.375 12.1359 7.34505 12.1359 8.54167C12.1359 9.19146 11.8253 9.62541 11.4623 9.97578C11.3114 10.1214 11.1393 10.2641 10.9738 10.4013C10.9493 10.4216 10.925 10.4417 10.901 10.4618C10.7076 10.6226 10.5141 10.7873 10.3228 10.9786C10.1275 11.1738 9.81096 11.1738 9.6157 10.9786C9.42044 10.7833 9.42044 10.4667 9.6157 10.2714C9.84111 10.046 10.0642 9.85706 10.2615 9.69296C10.2874 9.67141 10.3126 9.65046 10.3373 9.63001C10.5063 9.48977 10.6462 9.37363 10.7678 9.25625C11.0298 9.0034 11.1359 8.81235 11.1359 8.54167C11.1359 7.89733 10.6136 7.375 9.96924 7.375ZM9.97759 13.625H9.96925C9.69311 13.625 9.46925 13.4011 9.46925 13.125C9.46925 12.8489 9.69311 12.625 9.96925 12.625H9.97759C10.2537 12.625 10.4776 12.8489 10.4776 13.125C10.4776 13.4011 10.2537 13.625 9.97759 13.625Z"/>',
};
</script>

<template>
  <button
    class="custom-btn-svg-icon"
    :class="[size]"
    type="button"
    :aria-label="$t('eco_support_btn')"
  >
    <svg
      v-if="icon && icon in icons"
      class="sword-icon svg-icon svg-fill"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      v-html="icons[icon]"
    >
    </svg>
  </button>
</template>

<style lang="scss" scoped>

$base-size: 1.25rem;
$md-size: 1.5rem;
.custom-btn-svg-icon {
  border: none;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background: transparent;
  padding: 0;
  cursor: pointer;

  .svg-icon {
    fill: currentColor;
    stroke: none;
    width: 100%;
    height: 100%;
  }

  &.sm {
    width: $base-size;
    height: $base-size;
  }
  &.md {
    width: $md-size;
    height: $md-size;
  }

  &:hover {
    color: $secondary-color;
  }
}
</style>
